export default __webpack_public_path__ + "static/media/twitter.88d497cc.svg";